import { deleteApp, getApp, getApps, initializeApp } from 'firebase/app'
import { getAnalytics, isSupported } from 'firebase/analytics'
import { atomStateGenerator } from '@gaddario98/react-state'
import { useEffect } from 'react'
import { defaultAuthErrorFunction, defaultLoginMethods } from './defaultConfig'
import type { FirebaseConfigProps } from './types'
import type { Analytics } from 'firebase/analytics'

// Lazy initialization to avoid side effects at module load time
const _firebaseConfig: FirebaseConfigProps = {
  loginMethods: defaultLoginMethods,
  authErrorFunction: defaultAuthErrorFunction,
}

export const {
  atom: firebaseConfigAtom,
  useValue: useFirebaseConfigValue,
  useState: useFirebaseConfigState,
  useReset: useFirebaseConfigReset,
} = atomStateGenerator<FirebaseConfigProps>({
  key: 'firebaseConfig',
  defaultValue: _firebaseConfig,
  persist: false,
})

export const useFirebaseConfig = (value: Partial<FirebaseConfigProps>) => {
  const [config, setConfig] = useFirebaseConfigState()

  useEffect(() => {
    setConfig({ ...config, ...value })
  }, [value])
}

let firebaseApp = {
  apiKey: '',
  authDomain: '',
  databaseURL: '',
  projectId: '',
  storageBucket: '',
  messagingSenderId: '',
  appId: '',
  measurementId: '',
}

let analyticsInstance: Analytics | null = null

const inizialize = () => {
  if (firebaseApp.apiKey) {
    const app = initializeApp(firebaseApp)
    isSupported().then((supported) => {
      if (supported) analyticsInstance = getAnalytics(app)
    })
    return app
  }
}

const setFirebaseApp = async (config: Partial<typeof firebaseApp>) => {
  firebaseApp = { ...firebaseApp, ...config }

  if (getApps().length) {
    await deleteApp(getApp())
  }
  return inizialize()
}

export { setFirebaseApp, analyticsInstance }
